import React from "react";
import Sidebar from "../../../Components/Sidebar/Sidebar";
import { managerSideBarItems } from "./Routes";

const Navbar = () => {
  return <Sidebar sideBarItems={managerSideBarItems} />;
};

export default Navbar;
